import { Injectable } from '@angular/core';
import { environment } from './../../../environments/environment';
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable()
export class MarketingService {

  baseUrl: string = environment.api_base_url;

  constructor(public http: HttpClient) { }

  createMarketList(data) {
    return this.http.post(`${this.baseUrl}marketing/lists/create`, JSON.stringify(data));
  }

  getMarketingList() {
    return this.http.get(`${this.baseUrl}marketing/lists`);
  }

  updateList(data) {
    return this.http.post(`${this.baseUrl}marketing/lists/update`, JSON.stringify(data));
  }

  sendEmails(data) {
    return this.http.post(`${this.baseUrl}marketing/email/bulk`, JSON.stringify(data));
  }

  sendSmS(data) {
    return this.http.post(`${this.baseUrl}marketing/sms/bulk`, JSON.stringify(data))
  }
  sendBulkSmSByStatus(data){
    return this.http.post(`${this.baseUrl}marketing/sms_leads_by_status`, JSON.stringify(data));
  }
  sendSingleSmS(data) {
    return this.http.post(`${this.baseUrl}marketing/sms`, JSON.stringify(data));
  }

  sendSingleEmail(data) {
    return this.http.post(`${this.baseUrl}marketing/email`, JSON.stringify(data));
  }

  smsCredentials(data) {
    return this.http.post(`${this.baseUrl}remote/config/change/sms/credentials`, JSON.stringify(data));
  }

  addChannel(data) {
    return this.http.post(`${this.baseUrl}lead_channels`, JSON.stringify(data));
  }

  getChannels() {
    return this.http.get(`${this.baseUrl}lead_channels`);
  }

  getChannelData(id) {
    return this.http.get(`${this.baseUrl}lead_channels/${id}`)
  }

  deleteChannel(id) {
    return this.http.delete(`${this.baseUrl}lead_channels/${id}`)
  }

  editChannel(id, data) {
    return this.http.put(`${this.baseUrl}lead_channels/${id}`, JSON.stringify(data))
  }
  exportList(id,type) {
    return this.http.get(`${this.baseUrl}marketing/export/${id}/${type}`)
  }

}



// WEBPACK FOOTER //
// ./src/app/services/marketing/marketing.service.ts